export enum ENavigationErrorType {
    IE = 1,
    UnAuthenticated = 2,
    UnAuthorized = 3,
    URL = 4,
    DeprecatedVersion = 5
}
